/* eslint-disable no-shadow */
import React from "react";
import { Container, Col, Row } from "reactstrap";

import Editor from "react-simple-code-editor";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism.css";

import PortfolioNav from "../headerComponent/portfolioNav";
import HatchwayPractice from "./hatchway-practice/HatchwayPractice";

const Coding = () => {
  const [functionalCode, setFunctionalCode] = React.useState(
    `import React from "react";\nimport ReactDOM from "react-dom";\n\nconst App = () => {\n   return (<div>Hello, it's me</div>) \n};\n\nReactDOM.render(<App/>, document.getElementById('root'));`
  );

  const [classCode, setClassCode] = React.useState(
    `import React from "react";\nimport ReactDOM from "react-dom";\n\nclass App extends React.Component {\n   render() {\n     return (<div>Hello, it's me</div>)\n   } \n}\n\nReactDOM.render(<App/>, document.getElementById('root'));`
  );

  return (
    <Container className="portfolio__container">
      <Row>
        <Col xs="2" md="3" lg="4" />
        <Col xs="8" md="6" lg="4">
          <PortfolioNav />
        </Col>
        <Col xs="2" md="3" lg="4" />
      </Row>
      <Row>
        <Col>
          <h1>Coding</h1>
        </Col>
      </Row>
      <Row className="mt-5">
        <Col xs="12" md="6" lg="6">
          <h3>Functional Component</h3>
          <Editor
            className="container__editor"
            value={functionalCode}
            onValueChange={code => setFunctionalCode(code)}
            highlight={code => highlight(code, languages.js)}
            padding={30}
          />
        </Col>
        <Col xs="12" md="6" lg="6">
          <h3>Class Component</h3>
          <Editor
            className="container__editor"
            value={classCode}
            onValueChange={code => setClassCode(code)}
            highlight={code => highlight(code, languages.js)}
            padding={30}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <h3>Working with APIs</h3>
          <HatchwayPractice />
        </Col>
      </Row>
    </Container>
  );
};

export default Coding;
